module.exports = __webpack_public_path__ + "img/jardin1.9458c84c.jpg";